import { useContext } from "react";

import { MultiLayerEditContext } from "./MultiLayerEditProvider";

/**
 * Hook to access multi-layer edit context.
 * Must be used within a MultiLayerEditProvider.
 */
export const useMultiLayerEdit = () => {
  const context = useContext(MultiLayerEditContext);
  if (!context) {
    throw new Error("useMultiLayerEdit must be used within a MultiLayerEditProvider");
  }
  return context;
};
